import configuration from '../configuration.mjs';
import initSwedishSearchForm from './estate-search-page/swedish-search-form.mjs';
import initInternationalSearchForm from './estate-search-page/international-search-form.mjs';
import initCommercialSearchForm from './estate-search-page/commercial-search-form.mjs';
import CreateSearchAlertButtonHandler from './estate-search-page/create-search-alert-button-handler.mjs';
import SearchResultHandler from './estate-search-page/search-result-handler.mjs';
import SearchResultMapHandler from './estate-search-page/search-result-map-handler.mjs';

/**
 * @param {Element} rootElement
 */
export default (rootElement = document.body) => {
  const pageElement = rootElement?.querySelector('#estate-search-page');

  if(!pageElement) {
    return;
  }

  if(configuration.website === 'Sweden') {
    initSwedishSearchForm(pageElement);
  } else if(configuration.website === 'International') {
    initInternationalSearchForm(pageElement);
  } else if(configuration.website === 'Commercial') {
    initCommercialSearchForm(pageElement);
  } else {
    throw new Error(`Unknown website: ${configuration.website}`);
  }

  new SearchResultMapHandler(pageElement);
  new SearchResultHandler(pageElement);
  new CreateSearchAlertButtonHandler(pageElement);
};
